import { render, staticRenderFns } from "./BatchModifyFabric.vue?vue&type=template&id=14e7ff22&scoped=true"
import script from "./BatchModifyFabric.vue?vue&type=script&lang=js"
export * from "./BatchModifyFabric.vue?vue&type=script&lang=js"
import style0 from "./batch-modify.css?vue&type=style&index=0&id=14e7ff22&prod&scoped=true&lang=css&external"
import style1 from "./BatchModifyFabric.vue?vue&type=style&index=1&id=14e7ff22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_cache-loader@4.1.0_webpack@4.47.0_supports-_28b733ef3ef89602fda58894ac543489/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e7ff22",
  null
  
)

export default component.exports